import React, { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Typography, Button, Box, Link } from '@material-ui/core';

const STORAGE_KEY = 'cookieBannerDismissed';

const useStyles = makeStyles((theme) => ({
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1300,
    padding: theme.spacing(2, 3),
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  text: {
    flex: 1,
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  link: {
    color: theme.palette.secondary.main,
    fontWeight: 600,
    '&:hover': {
      color: theme.palette.secondary.light,
    },
  },
  button: {
    backgroundColor: theme.palette.secondary.main,
    color: '#fff',
    minWidth: 120,
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
}));

export const CookieBanner: React.FC = () => {
  const classes = useStyles();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const dismissed = localStorage.getItem(STORAGE_KEY);
      if (dismissed !== 'true') {
        setIsVisible(true);
      }
    } catch (error) {
      console.error('Error reading cookie banner state:', error);
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      console.error('Error saving cookie banner state:', error);
    }
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <Paper className={classes.banner} elevation={8} square>
      <Box className={classes.text}>
        <Typography variant="body1">
          Questo sito utilizza cookie tecnici necessari al corretto funzionamento e alla sicurezza del servizio. Per
          maggiori informazioni consulta la nostra{' '}
          <Link component={RouterLink} to="/cookie-policy" className={classes.link}>
            Cookie Policy
          </Link>
          .
        </Typography>
      </Box>
      <Button variant="contained" className={classes.button} onClick={handleDismiss}>
        Ho capito
      </Button>
    </Paper>
  );
};
